import { render, staticRenderFns } from "./EducationalJoiningApplicationChangeApproveRejected.vue?vue&type=template&id=03bf4002&"
import script from "./EducationalJoiningApplicationChangeApproveRejected.vue?vue&type=script&lang=js&"
export * from "./EducationalJoiningApplicationChangeApproveRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports